import {comMapping} from "../../../../../../../util/Function/comMapping";

export function getdata() {
    let obj = {
        formlist: [
            {
                prop: 'fentshuie',
                label: '分摊税额',
                type: 'input',
                width: "120px",
                disabled: true
            },
            {
                prop: 'financialAnnotations',
                label: '财务批注',
                type: 'textarea',
            },
        ],
        formdata: {
            fentshuie: '',
            financialAnnotations: ''
        }
    };
    return obj
}
